import type { Messages } from '../en'

export const home: Messages['home'] = {
  // Hero greeting + shell
  greeting: (hour) => (hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite'),
  greetingFallbackName: 'tudo bem?',
  yourTeam: 'sua equipe',
  loadingWorkshop: 'Carregando sua fábrica…',

  // Lede — the month's story in one sentence
  ledeDefault: 'Veja o que seus fluxos andaram fazendo.',
  ledeEmpty: 'Nada foi executado neste mês ainda. Inicie um fluxo e seus resultados aparecerão aqui.',
  ledeFirstRuns: (waiting, live) =>
    `As primeiras execuções do mês estão em andamento${
      waiting === 1
        ? ' — uma execução está aguardando você agora.'
        : waiting > 1
          ? ` — ${waiting} execuções estão aguardando você agora.`
          : live === 1
            ? ' — uma execução está em andamento agora.'
            : live > 1
              ? ` — ${live} execuções estão em andamento agora.`
              : '.'
    }`,
  ledeDeliveredPrefix: 'Seus fluxos entregaram',
  ledeDeliveredMid: 'em',
  ledeDeliveredSuffix: 'neste mês',
  ledeTail: (waiting, live) =>
    waiting === 1
      ? ' — e uma execução está aguardando você agora.'
      : waiting > 1
        ? ` — e ${waiting} execuções estão aguardando você agora.`
        : live === 1
          ? ' — e uma execução está em andamento agora.'
          : live > 1
            ? ` — e ${live} execuções estão em andamento agora.`
            : '.',
  docsCount: (n) => (n === 1 ? '1 documento' : `${n} documentos`),
  runsCount: (n) => (n === 1 ? '1 execução' : `${n} execuções`),

  // Hero cards
  allQuietTitle: 'Tudo tranquilo — nada precisa de você agora',
  allQuietSub: 'Inicie um fluxo e veja a fábrica entrar em ação.',
  browseFlows: 'Explorar fluxos',
  hasQuestionForYou: (name) => `${name} tem uma pergunta para você`,
  attnWithQuestion: (question, ago) => `“${question}” · perguntou ${ago}`,
  attnWaitingReply: (ago) => `Aguardando sua resposta · perguntou ${ago}`,
  moreWaiting: (extra) => `+${extra} aguardando`,
  answer: 'Responder',
  liveBadge: 'ao vivo',
  startedAgo: (ago) => `iniciada ${ago}`,
  byPerson: (name) => `por ${name}`,
  moreRunning: (extra) => `+${extra} em execução`,
  watch: 'Acompanhar',

  // Workshop stage captions
  stageSetting: 'Preparando o palco…',
  stageBusyAndWaiting: (live, waiting) =>
    `${live} ${live === 1 ? 'execução' : 'execuções'} em andamento · ${waiting} aguardando você`,
  stageBusy: (live) => `A fábrica está movimentada — ${live} ${live === 1 ? 'execução' : 'execuções'} em andamento`,
  stagePaused: 'A fábrica está em pausa — uma pergunta aguarda você',
  stageQuiet: 'A fábrica está tranquila — pronta quando você estiver',

  // Month stats band
  thisMonthAt: (tenant) => `Este mês em ${tenant}`,
  monthRange: (monthName, day) => `1 – ${day} de ${monthName}`,
  partialChip: 'parcial',
  partialTooltip: 'Mês muito movimentado — os números abaixo são valores mínimos.',
  fullHistory: 'Ver histórico',
  statRunsCompleted: 'Execuções concluídas',
  statSuccessRate: 'Taxa de sucesso',
  statDocsDelivered: 'Documentos entregues',
  statMedianTurnaround: 'Prazo típico de entrega',
  runsOfTotal: (succeeded, total) => `${succeeded} de ${total} ${total === 1 ? 'execução' : 'execuções'}`,
  noFinishedRuns: 'nenhuma execução concluída ainda',
  docsThisWeek: (n) => `▲ ${n} esta semana`,
  noneThisWeek: 'nenhum esta semana',
  fromLaunchToFiles: 'do início à entrega',
  runsPerDay14: 'Execuções por dia · últimos 14 dias',
  dayRuns: (day, count) => `${day} · ${count} ${count === 1 ? 'execução' : 'execuções'}`,
  firstActiveMonth: 'primeiro mês ativo',
  paceUp: (pct, month) => `▲ ${pct}% vs ${month}`,
  paceDown: (pct, month) => `▼ ${pct}% vs ${month}`,
  paceEven: (month) => `no mesmo ritmo de ${month}`,

  // Latest results
  latestResults: 'Últimos resultados',
  history: 'Histórico',
  firstDeliverable: 'Sua primeira entrega aparecerá aqui assim que uma execução terminar.',
  // Feminine: the outcome describes an execução (matches runs.statusLabel).
  outcomeDone: 'Concluída',
  outcomePartial: 'Parcial',
  outcomeFailed: 'Falhou',
  startedByName: (name) => `Iniciada por ${name}`,
  filesCount: (n) => (n === 1 ? '1 arquivo' : `${n} arquivos`),

  // Quick flows
  startSomething: 'Comece algo',
  allFlows: 'Todos os fluxos',
  noFlowsAvailable: 'Nenhum fluxo disponível para sua conta ainda. Volte em breve.'
}
